<!--
 * @Descripttion: 说明
 * @Author: 聂章帅
 * @Date: 2024-10-17 16:29:55
 * @LastEditors: 聂章帅
 * @LastEditTime: 2024-10-17 16:33:06
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { cityOption } from './util/mainOption'
export default {
  created () {

    document.title = cityOption.cityName +
      (cityOption.homeTitle
        ? cityOption.homeTitle
        : "农村集体“三资”监督管理平台")
  },
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

body,
html {
  padding: 0;
  margin: 0;
}
</style>